import { behaviorActionTypeName } from '@/common/app/modules/recommend/behaviorLog'
import { dateTimeStr } from '@/common/form/date'
import { BehaviorLog } from '@/common/model/recommend/behavior'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

const formatDwell = (ms: number | null | undefined): string => {
  if (ms == null) return '-'
  if (ms < 1000) return `${ms}ms`
  const sec = Math.floor(ms / 1000)
  if (sec < 60) return `${sec}秒`
  const min = Math.floor(sec / 60)
  const remSec = sec % 60
  return remSec > 0 ? `${min}分${remSec}秒` : `${min}分`
}

interface Props {
  log: BehaviorLog
}

const BehaviorListRow = ({ log }: Props) => (
  <TableRow>
    <TableRowItem>
      <Text nowrap>{dateTimeStr(log.created_at)}</Text>
    </TableRowItem>
    <TableRowItem>
      <Badge badgeType={BadgeType.SQUARE_TERTIARY}>{behaviorActionTypeName(log.action_type)}</Badge>
    </TableRowItem>
    <TableRowItem>
      {log.visitor_id ? <Text>{log.visitor_id}</Text> : <Text color={TextColor.SECONDARY}>-</Text>}
    </TableRowItem>
    <TableRowItem>
      {log.session_id ? <Text>{log.session_id}</Text> : <Text color={TextColor.SECONDARY}>-</Text>}
    </TableRowItem>
    <TableRowItem>
      {log.customer_id ? (
        <Text>{log.customer_id}</Text>
      ) : (
        <Text color={TextColor.SECONDARY}>-</Text>
      )}
    </TableRowItem>
    <TableRowItem>
      {log.item_id ? (
        <code className='bg-ruri-secondary text-fill-brand rounded px-1.5 py-0.5 font-mono text-xs'>
          {log.item_id}
        </code>
      ) : (
        <Text color={TextColor.SECONDARY}>-</Text>
      )}
    </TableRowItem>
    <TableRowItem>
      {log.category_id ? (
        <code className='bg-ruri-secondary text-fill-brand rounded px-1.5 py-0.5 font-mono text-xs'>
          {log.category_id}
        </code>
      ) : (
        <Text color={TextColor.SECONDARY}>-</Text>
      )}
    </TableRowItem>
    <TableRowItem>
      {log.device_type ? (
        <Badge badgeType={BadgeType.SQUARE_SECONDARY}>{log.device_type}</Badge>
      ) : (
        <Text color={TextColor.SECONDARY}>-</Text>
      )}
    </TableRowItem>
    <TableRowItem>
      <Text color={TextColor.SECONDARY}>{log.browser || '-'}</Text>
    </TableRowItem>
    <TableRowItem>
      <Text color={TextColor.SECONDARY} nowrap>
        {formatDwell(log.dwell_time_ms)}
      </Text>
    </TableRowItem>
    <TableRowItem width={200}>
      <div className='max-w-[200px] truncate' title={log.page_url || undefined}>
        <Text color={TextColor.SECONDARY}>{log.page_url || '-'}</Text>
      </div>
    </TableRowItem>
    <TableRowItem width={200}>
      <div className='max-w-[200px] truncate' title={log.referrer || undefined}>
        <Text color={TextColor.SECONDARY}>{log.referrer || '-'}</Text>
      </div>
    </TableRowItem>
  </TableRow>
)

export default BehaviorListRow
